import * as tslib_1 from "tslib";
/* eslint-disable */
//This file is copied from react-select, for overriding the select from mouseDown to mouseUp

import React, { Component } from 'react';
import { Option as OriginalOption } from 'react-select';
import cx from 'classnames';

var Option =
/** @class */
function (_super) {
  tslib_1.__extends(Option, _super);

  function Option() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onFocus = function (event) {
      if (!_this.props.isFocused) {
        _this.props.onFocus(_this.props.option, event);
      }
    };

    _this.handleMouseUp = function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.props.onSelect(_this.props.option, event);
    };

    _this.handleMouseDown = function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    };

    _this.handleMouseEnter = function (event) {
      _this.onFocus(event);
    };

    _this.handleMouseMove = function (event) {
      _this.onFocus(event);
    };

    _this.handleTouchEnd = function (event) {
      // Check if the view is being dragged, In this case
      // we don't want to fire the click event (because the user only wants to scroll)
      if (_this.dragging) return;

      _this.handleMouseUp(event);
    };

    _this.handleTouchMove = function () {
      // Set a flag that the view is being dragged
      _this.dragging = true;
    };

    _this.handleTouchStart = function () {
      // Set a flag that the view is not being dragged
      _this.dragging = false;
    };

    return _this;
  }

  Option.prototype.render = function () {
    var _a = this.props,
        option = _a.option,
        instancePrefix = _a.instancePrefix,
        optionIndex = _a.optionIndex;
    var className = cx(this.props.className, option.className);
    return option.disabled ? React.createElement(OriginalOption, tslib_1.__assign({}, this.props), this.props.children) : React.createElement("div", {
      className: className,
      style: option.style,
      role: "option",
      "aria-label": option.label,
      onMouseUp: this.handleMouseUp,
      onMouseDown: this.handleMouseDown,
      onMouseEnter: this.handleMouseEnter,
      onMouseMove: this.handleMouseMove,
      onTouchStart: this.handleTouchStart,
      onTouchMove: this.handleTouchMove,
      onTouchEnd: this.handleTouchEnd,
      id: instancePrefix + "-option-" + optionIndex,
      title: option.title
    }, this.props.children);
  };

  return Option;
}(Component);

Option.propTypes = OriginalOption.propTypes;
export default Option;

try {
  // @ts-ignore
  Option.__docgenInfo = {
    "description": "",
    "displayName": "Option",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}